import { loadView } from '@/helper/utils'
import { mainLayout } from '@/components/layouts/Main'

export default {
  path: '/carrier',
  component: mainLayout(loadView('carrier/Carrier')),
  children: [
    {
      path: ':carrier',
      name: 'CarrierDetail',
      component: loadView('carrier/CarrierDetail'),
      meta: { requiresAuth: true }
    }
  ]
}
